import { get, getOr, flatMap, flow, every, isEmpty } from 'lodash/fp'
import { loader } from 'graphql.macro'
import { sortStringsValues } from '@utils/shared'
import { GET_NARRATIVES } from 'apollo/queries/narratives'
import { getProduct } from 'store/selectors/productSelector'
import { GET_PRODUCT_CATEGORIES } from 'apollo/queries/categories'

const VIEW_CATEGORIES_QUERY = loader(
  '../../queries/ViewCategoriesQuery.graphql',
)
const PRODUCT_REVIEWS_QUERY = loader(
  '../../queries/ProductReviewPlatformsQuery.graphql',
)

export const SET_MENTIONS_FILTERS = 'SET_MENTIONS_FILTERS'
export const ADD_CATEGORY = 'ADD_CATEGORY'

export const REQ_META_MENTIONS_FILTERS = 'REQ_META_MENTIONS_FILTERS'
export const RES_META_MENTIONS_FILTERS = 'RES_META_MENTIONS_FILTERS'

export const REQ_META_REVIEW_PLATFORMS_FILTERS =
  'REQ_META_REVIEW_PLATFORMS_FILTERS'
export const RES_META_REVIEW_PLATFORMS_FILTERS =
  'RES_META_REVIEW_PLATFORMS_FILTERS'

/**
 * Updates the available mentions categories
 */
export function addCategory(category) {
  return dispatch => {
    dispatch({ type: ADD_CATEGORY, payload: category })
  }
}

/**
 * Fetch the categories for the filters
 */

function reqMetadata() {
  return { type: REQ_META_MENTIONS_FILTERS }
}

export function resMetadata({ categories, themes, narratives }) {
  return {
    type: RES_META_MENTIONS_FILTERS,
    payload: { categories, themes, narratives },
  }
}

export function fetchCategories(productId, viewId, apolloClient) {
  const productCategoriesQuery = {
    query: GET_PRODUCT_CATEGORIES,
    variables: {
      productId,
    },
  }
  const viewCategoriesQuery = {
    query: VIEW_CATEGORIES_QUERY,
    variables: {
      productId,
      viewId,
    },
  }
  return async (dispatch, getState) => {
    dispatch(reqMetadata())

    let categories = []
    let themes = []
    let narratives = []

    if (viewId) {
      const { data } = await apolloClient.query(viewCategoriesQuery)
      categories = get('user.product.categories', data)
      themes = get('user.product.view.themes', data)

      // Allow Views without themes to have all categories by default
      if (every(isEmpty, [categories, themes])) {
        const { data: retryData } = await apolloClient.query(
          productCategoriesQuery,
        )
        categories = get('getProduct.categories', retryData)
      }
    } else {
      const { data } = await apolloClient.query(productCategoriesQuery)
      categories = get('getProduct.categories', data)
    }

    const sortedCategories = sortStringsValues([...categories], 'name')

    const state = getState()
    const isNarrativesEnabled = getProduct(state).narrativesEnabled

    if (isNarrativesEnabled) {
      const { data } = await apolloClient.query({
        query: GET_NARRATIVES,
      })

      narratives = getOr([], 'getNarratives', data)
    }

    return dispatch(
      resMetadata({ categories: sortedCategories, themes, narratives }),
    )
  }
}

export function fetchReviewPlatforms(productId, apolloClient) {
  return async dispatch => {
    dispatch({ type: REQ_META_REVIEW_PLATFORMS_FILTERS })
    const { data } = await apolloClient.query({
      query: PRODUCT_REVIEWS_QUERY,
      variables: { productId },
    })

    const reviewPlatforms = flow(
      getOr([], 'user.product.feeds'),
      flatMap('reviewPlatforms'),
    )(data)

    return dispatch({
      type: RES_META_REVIEW_PLATFORMS_FILTERS,
      payload: { reviewPlatforms },
    })
  }
}
